import StyledRadio from './StyledRadio';

export default StyledRadio;
